// The sub-controls strip's overflow rule (05c, main.js watchControlsOverflow, moved as-is):
// controls that don't fit are hidden, rightmost first. It watches the strip, so it runs on
// every module resize by itself.
//
// Also called by widgets that build their own strip at render time (SubControls) or add
// to the shared one (SubControlsSlot) — each call adds one more observer, as main.js did.

export function watchControlsOverflow(mod: HTMLElement): void {
  const controls = mod.querySelector<HTMLElement>(".module-sub-controls");
  if (!controls) return;
  const strip = controls;

  function update(): void {
    // The styled dropdowns (a button, not a native <select> — whose menu can't be styled
    // on Safari / macOS) are measured and hidden the same way.
    const selects = Array.from(strip.querySelectorAll<HTMLElement>("select, .styled-select-trigger"));
    if (!selects.length) return;

    selects.forEach((s) => {
      s.style.display = "";
    });

    const cs = getComputedStyle(strip);
    const available = strip.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    // main.js's `|| 10`: "normal" parses to NaN.
    const gap = parseFloat(cs.columnGap) || 10;

    let used = 0;
    let overflow = false;
    selects.forEach((s, i) => {
      if (overflow) {
        s.style.display = "none";
        return;
      }
      const needed = used + (i > 0 ? gap : 0) + s.offsetWidth;
      if (needed > available) {
        s.style.display = "none";
        overflow = true;
      } else {
        used = needed;
      }
    });
  }

  new ResizeObserver(update).observe(strip);
}
